module.exports = __webpack_public_path__ + "01641c5334301f2648a9d0b8edb6dda3.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1/public/games/Space-Marine_1.jpg
// module id = 436
// module chunks = 0